import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { FormErrorDirective, InputComponent } from '@core/user-interface-legacy';

import type { DynamicPrependInputConfig } from '../../types';
import { DynamicFormEventService } from '../dynamic-form/dynamic-form-event.service';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';

export class PrependInputAdapter extends DynamicFormInput<DynamicPrependInputConfig> {}

@Component({
  selector: 'rti-prepend-input-adapter',
  template: ` <div layout-horizontal layout-align-items-center class="input-with-prefix">
    <span margin-right-small-xx>{{ input().config.prepend }}- </span>
    <rt-input
      variant="rounded"
      [formControl]="input().control"
      [readOnly]="!!input().config.readOnly"
      [placeholder]="input().config.placeholder || ''"
      [rtFormError]="$any(input().formError)"
      (keyup.enter)="save()"
    />
  </div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [InputComponent, ReactiveFormsModule, FormErrorDirective],
})
export class PrependInputAdapterComponent {
  private readonly dynamicFormService = inject(DynamicFormEventService);

  public readonly input = input<PrependInputAdapter>(undefined!);

  public save(): void {
    this.dynamicFormService.submit$.next();
  }
}
